import {
  MarketsIndustrialPremisesListingConfig,
  MarketsParkingSpotListingConfig,
} from '@pigello/construct-core';
import { ApartmentQueueConfig } from '@pigello/pigello-matrix';
import z from 'zod/v4';
import { DefaultPresetSchema } from './default-preset-schema';
import type { PresetConfig } from './types';
import { createPresetSchema } from './utils';

// Apartment choices come from matrix for now: construct-core does not have the
// EXTERNAL queue type yet. Swap back to MarketsApartmentListingConfig once it does.
const APARTMENT_QUEUE_TYPES = (
  ApartmentQueueConfig.fields.queueType.choices ?? []
).map((choice) => String(choice.v)) as [string, ...string[]];

export const ListingQueueTypeDataSchema = z.object({
  apartment: z.enum(APARTMENT_QUEUE_TYPES).nullable(),
  industrialpremises: z
    .enum(
      MarketsIndustrialPremisesListingConfig.fields.queueType.validations
        .choices
    )
    .nullable(),
  parkingspot: z
    .enum(MarketsParkingSpotListingConfig.fields.queueType.validations.choices)
    .nullable(),
});

export type ListingQueueTypePresetData = z.infer<
  typeof ListingQueueTypeDataSchema
>;

export const V1Schema = createPresetSchema('1', ListingQueueTypeDataSchema);

export const LISTING_QUEUE_TYPE_PRESET_IDENTIFIER = 'listing.queuetype';
// Single preset, so one fixed key per owner
export const LISTING_QUEUE_TYPE_PRESET_KEY = 'default';

const ListingQueueTypePresetSchema = z.object({
  ...DefaultPresetSchema.shape,
  context: z.literal(LISTING_QUEUE_TYPE_PRESET_IDENTIFIER),
  data: V1Schema,
});

export const ListingQueueTypePreset = {
  identifier: LISTING_QUEUE_TYPE_PRESET_IDENTIFIER,
  currentSchema: ListingQueueTypePresetSchema,
  currentVersion: '1',
  migrations: null,
  single: true,
} as const satisfies PresetConfig;
